var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaveShuru(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#8fd460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7 4.129C5.74 5.16 5.11 5.79 4.129 7 5.11 8.21 5.74 8.84 7 9.871"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8fd460",
    strokeLinecap: "round",
    d: "M10.482 4.135a86.718 86.718 0 0 0-.063-1.54C10.374 1.678 9.6.923 8.587.85a39.976 39.976 0 0 0-5.67 0c-1.012.072-1.787.827-1.833 1.746A88.811 88.811 0 0 0 .977 7c0 1.511.037 2.985.107 4.404.046.92.82 1.674 1.833 1.746a39.962 39.962 0 0 0 5.67 0c1.012-.072 1.787-.827 1.832-1.746.026-.506.046-1.02.063-1.539"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8fd460",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.023 7 4.161 7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaveShuru);
export default __webpack_public_path__ + "static/media/leave_shuru.cee2c61cbbfd9c2ae6aa521adf105030.svg";
export { ForwardRef as ReactComponent };